import React from 'react'

export const CircleX = () => {
  return (
    <svg width='14' height='15' viewBox='0 0 14 15' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M0 7.25C0 3.39453 3.11719 0.25 7 0.25C10.8555 0.25 14 3.39453 14 7.25C14 11.1328 10.8555 14.25 7 14.25C3.11719 14.25 0 11.1328 0 7.25ZM4.78516 5.96484L6.07031 7.25L4.78516 8.53516C4.51172 8.80859 4.51172 9.21875 4.78516 9.46484C5.03125 9.73828 5.44141 9.73828 5.6875 9.46484L6.97266 8.17969L8.28516 9.46484C8.53125 9.73828 8.94141 9.73828 9.1875 9.46484C9.46094 9.21875 9.46094 8.80859 9.1875 8.53516L7.90234 7.25L9.1875 5.96484C9.46094 5.71875 9.46094 5.30859 9.1875 5.03516C8.94141 4.78906 8.53125 4.78906 8.28516 5.03516L6.97266 6.34766L5.6875 5.03516C5.44141 4.78906 5.03125 4.78906 4.78516 5.03516C4.51172 5.30859 4.51172 5.71875 4.78516 5.96484Z'
        fill='#FF6262'
      />
    </svg>
  )
}
